<template>
  <div>
    <div class="m-background m-background--blue"></div>
    <div class="m-header m-header--blue">
      <div class="m-header__start">
          <router-link class="m-header__link m-header__link--home" to="/">
            <img src="~@/assets/images/icon__home.png"/>
          </router-link>
        </div>
    </div>
    <div class="l-container">
      <h4 class="u-text--white">Explore Careers</h4>
      <h6 class="u-text--white">Choose a career to find out more:</h6>
      <div class="m-careers">
        <div class="columns is-gapless">
          <div class="column is-3">
            <!-- <h2 class="m-career__header m-career__header--map">Map</h2> -->
            <template v-for="(career, index) in mapCareers" >
              <a :key="index" class="m-career" :class="['m-career--'] + career.category"
               target="_blank" :href="getDocumentDomain + career.document"
               @click="registerClick(career.name)">
                <span class="m-career__text">{{ career.name }}</span>
              </a>
            </template>
          </div>
          <div class="column is-3">
            <!-- <h2 class="m-career__header m-career__header--design">Design</h2> -->
            <template v-for="(career, index) in designCareers">
              <a :key="index" class="m-career" :class="['m-career--'] + career.category"
               target="_blank" :href="getDocumentDomain + career.document"
               @click="registerClick(career.name)">
                <span class="m-career__text">{{ career.name }}</span>
              </a>
            </template>
          </div>
          <div class="column is-3">
            <!-- <h2 class="m-career__header m-career__header--build">Build</h2> -->
            <template v-for="(career, index) in buildCareers">
              <a :key="index" class="m-career" :class="['m-career--'] + career.category"
               target="_blank" :href="getDocumentDomain + career.document"
               @click="registerClick(career.name)">
                <span class="m-career__text">{{ career.name }}</span>
              </a>
            </template>
          </div>
          <div class="column is-3">
            <!-- <h2 class="m-career__header m-career__header--manage">Manage</h2> -->
            <template v-for="(career, index) in manageCareers">
              <a :key="index" class="m-career" :class="['m-career--'] + career.category"
               target="_blank" :href="getDocumentDomain + career.document"
               @click="registerClick(career.name)">
                <span class="m-career__text">{{ career.name }}</span>
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
    <img src="~@/assets/images/rics-logo.png" class="m-logo m-logo--bottom-right" />
    <h4 class="m-brand m-logo m-logo--bottom-left">MEGA CITY</h4>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getAllCareers', 'getDocumentDomain']),
    mapCareers() {
      const category = 'map';
      const mapCareers = this.getAllCareers.filter(career => career.category === category);
      return mapCareers;
    },
    designCareers() {
      const category = 'design';
      const designCareers = this.getAllCareers.filter(career => career.category === category);
      return designCareers;
    },
    buildCareers() {
      const category = 'build';
      const buildCareers = this.getAllCareers.filter(career => career.category === category);
      return buildCareers;
    },
    manageCareers() {
      const category = 'manage';
      const manageCareers = this.getAllCareers.filter(career => career.category === category);
      return manageCareers;
    },
  },
  methods: {
    registerClick(career) {
      this.$gtm.trackEvent({
        event: 'ricscta-click',
        'ricscta-name': 'explore-careers',
        'ricscta-label': career,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-home {
    color: white;
    width: 100px;
    padding-left: 30px;
    &:hover {
      background: none;
    }
  }
  h4 {
    margin-bottom: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Careers/Listing.vue